var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ux-page-wrapper ux-bg-gray",class:{'ux-page-fixed':_vm.fixed}},[_c('div',{staticClass:"ux-page-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }